<template>
  <div>
    <h1 class="headline">Agent Performance Summary</h1>
    <div class="my-4">
      <date-filter v-model="selectedDate" default-filter="last_7_days"></date-filter>
    </div>
    <div :style="`border: 1px solid ${$vuetify.theme.primary}; border-radius: 8px`" class="pa-4">
      <v-layout wrap align-center>
        <v-flex shrink class="pa-2"> Select Agent </v-flex>
        <v-flex xs12 md4 class="default-input pa-2">
          <multiselect
            v-model="filterAgent"
            :options="agentOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            deselect-label
            @input="handleFetchData()"
          ></multiselect>
        </v-flex>
      </v-layout>

      <div>
        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <apexchart
          v-if="series.length > 0 && !loading"
          :key="chartKey"
          ref="chart"
          type="bar"
          :height="chartHeight"
          width="100%"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import Apexchart from 'vue-apexcharts'
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading.vue'
import Multiselect from 'vue-multiselect'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'

export default {
  components: {
    Apexchart,
    DashboardGraphLoading,
    Multiselect,
    DateFilter
  },
  data() {
    return {
      loading: false,
      filterAgent: null,
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(3, 'days').format('YYYY-MM-DD')
      },
      chartKey: 0,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: dayjs().format('DD MMM YYYY')
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    agentList() {
      return this.$store.state.agents
    },
    agentOptions() {
      let options = []
      if (this.isAgent) {
        options = this.agentList
          .filter((agent) => agent.adminid === this.$store.state.userid)
          .map((el) => el.adminid)
      } else {
        options = this.agentList.map((el) => el.adminid)
      }
      return options
    },
    isAgent() {
      return this.$store.state.privilege && this.$store.state.privilege.role == 'agent'
    },
    chartHeight() {
      const countTag = Object.keys(this.chartOptions.xaxis.categories).length
      let height = '350'
      if (countTag > 25) {
        height = '1000'
      } else if (countTag > 15) {
        height = '700'
      } else if (countTag > 7) {
        height = '500'
      }
      return height
    }
  },
  watch: {
    selectedDate: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    }
  },
  mounted() {
    if (this.agentList.length === 0) {
      this.$store.dispatch('loadAgents')
    }

    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        if (vm.isAgent) {
          vm.filterAgent = vm.$store.state.userid
        }

        const data = {
          page_id: vm.selectedBot.pageid,
          start_date: dayjs(vm.selectedDate.start).format(DATETIME.DATE_FORMAT),
          end_date: dayjs(vm.selectedDate.end).format(DATETIME.DATE_FORMAT),
          admin_id: vm.filterAgent ? vm.filterAgent : 'all'
        }

        vm.loading = true
        const response = await ticket3AgentManagementApi.getCountTicketClosedByAgent({
          params: data
        })

        if (response && response.status === 200 && response.data) {
          const responseData = response.data.data || []
          vm.handleTransformChartData(responseData)
        }
        vm.loading = false
      } catch (error) {
        vm.loading = false
        console.error(error)
      }
    },
    handleTransformChartData(data) {
      const assignmentData = []
      const closedData = []
      const categories = []

      if (data && data.length > 0) {
        data.map((item) => {
          if (item.assignment) {
            assignmentData.push(item.assignment.toString())
          }
          if (item.closed) {
            closedData.push(item.closed.toString())
          }
          if (item.starttime) {
            categories.push(dayjs(item.starttime).format('MMM D, YYYY'))
          }
        })
      }

      this.series = [
        { name: 'Ticket Assiged', data: assignmentData },
        { name: 'Closed case', data: closedData }
      ]
      this.chartOptions.xaxis.categories = categories
      this.chartKey++
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/Summary/index.vue